import * as XLSX from "xlsx";

export const CURRENCIES = [
  { code: "JPY", name: "Yen Jepang" }, { code: "SGD", name: "Dolar Singapura" }, { code: "AUD", name: "Dolar Australia" },
  { code: "THB", name: "Baht Thailand" }, { code: "KRW", name: "Won Korea" }, { code: "MYR", name: "Ringgit Malaysia" },
  { code: "HKD", name: "Dolar Hong Kong" }, { code: "TWD", name: "Dolar Taiwan" }, { code: "CNY", name: "Yuan China" },
  { code: "USD", name: "Dolar AS" }, { code: "EUR", name: "Euro" }, { code: "GBP", name: "Pound Inggris" },
  { code: "NZD", name: "Dolar Selandia Baru" }, { code: "PHP", name: "Peso Filipina" }, { code: "VND", name: "Dong Vietnam" },
  { code: "AED", name: "Dirham UEA" }, { code: "SAR", name: "Riyal Saudi" }, { code: "TRY", name: "Lira Turki" },
  { code: "CHF", name: "Franc Swiss" }, { code: "CAD", name: "Dolar Kanada" }, { code: "INR", name: "Rupee India" },
];
export const CURRENCY_SYMBOLS = { IDR: "Rp", JPY: "¥", THB: "฿", EUR: "€", USD: "$", KRW: "₩", SGD: "S$", AUD: "A$", MYR: "RM", HKD: "HK$", TWD: "NT$", CNY: "¥", GBP: "£", NZD: "NZ$", PHP: "₱", VND: "₫", INR: "₹", CHF: "CHF", CAD: "C$" };

export function fmtIDR(n) {
  return "Rp " + Math.round(n || 0).toLocaleString("id-ID");
}

export function fmtCur(n, cur = "IDR") {
  const sym = CURRENCY_SYMBOLS[cur] || cur + " ";
  return sym + " " + Math.round(n || 0).toLocaleString("id-ID");
}

export function fmtDate(s) {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
}

export const ITEM_STATUS = {
  di_order: { label: "Di Order", cls: "bg-sky-50 text-sky-700 border-sky-300", dot: "bg-sky-500" },
  sudah_dibeli: { label: "Sudah Dibeli", cls: "bg-teal-50 text-teal-800 border-teal-300", dot: "bg-teal-600" },
  dibatalkan: { label: "Dibatalkan", cls: "bg-rose-50 text-rose-700 border-rose-300", dot: "bg-rose-500" },
  diganti: { label: "Disubstitusi", cls: "bg-purple-50 text-purple-700 border-purple-300", dot: "bg-purple-500" },
  dikirim_ke_indo: { label: "Kirim ke Indo", cls: "bg-blue-50 text-blue-700 border-blue-300", dot: "bg-blue-600" },
  dikirim_ke_customer: { label: "Kirim ke Customer", cls: "bg-emerald-100 text-emerald-900 border-emerald-400", dot: "bg-emerald-700" },
};

export const PAYMENT_STATUS = {
  pending: { label: "Menunggu Bayar", cls: "bg-amber-50 text-amber-800 border-amber-300", dot: "bg-amber-500" },
  valid: { label: "Lunas / Valid", cls: "bg-emerald-50 text-emerald-800 border-emerald-300", dot: "bg-emerald-600" },
};

export const ORDER_STATUS = {
  pending_payment: { label: "Menunggu Pembayaran", cls: "bg-amber-50 text-amber-800 border-amber-300", dot: "bg-amber-500" },
  paid: { label: "Order Valid", cls: "bg-emerald-50 text-emerald-800 border-emerald-300", dot: "bg-emerald-600" },
};

export const EVENT_STATUS = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  open_po: "bg-sky-50 text-sky-700 border-sky-300",
  shopping_live: "bg-blue-50 text-blue-700 border-blue-300",
  shipping: "bg-purple-50 text-purple-700 border-purple-300",
  finished: "bg-emerald-50 text-emerald-800 border-emerald-300",
  reconciled: "bg-slate-800 text-white border-slate-800",
};

export const ROLE_BADGE = {
  admin: "bg-slate-900 text-white",
  ops: "bg-blue-600 text-white",
  sales: "bg-blue-600 text-white",
  shopper: "bg-amber-600 text-white",
  finance: "bg-emerald-700 text-white",
};

export function exportCSV(rows, columns, filename) {
  const data = rows.map((r) => Object.fromEntries(columns.map((c) => {
    const v = c.raw ? c.raw(r) : r[c.key];
    return [c.label, v ?? ""];
  })));
  const ws = XLSX.utils.json_to_sheet(data, { header: columns.map((c) => c.label) });
  ws["!cols"] = columns.map((c) => ({ wch: Math.max(12, Math.min(40, c.label.length + 4)) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, `${filename}.xlsx`);
}
